const MATERIALS_BOXES = [
  {
    url: "https://www.vedinimas.lt/pdn-125-2-difuzoriaus-pajungimo-dezute-plastikas-300mm-ilgio-paprastas-montavimas",
    icon: "https://www.vedinimas.lt/images/uploader/pd/588x588.g/pdn-125-2-difuzoriaus-pajungimo-dezute-plastikas-300mm-ilgio-paprastas-montavimas-1-1.jpg",
    code: "904000009",
    name: "Difuzoriaus pajungimo dėžė Basic P 125-2x75",
    productGroup: "normal",
    good_id: 47903,
  },
  {
    url: "https://www.vedinimas.lt/sr-s-dvs-p-125-padavimo-difuzorius",
    icon: "https://www.vedinimas.lt/images/uploader/sr/565x565.g/sr-s-dvs-p-125-padavimo-difuzorius-2.png?t=615873",
    code: "800100002",
    name: "Difuzorius oro padavimui ir ištraukimui DVS/PDVS 125",
    productGroup: "normal",
    good_id: 46975,
  },
  {
    url: "https://www.vedinimas.lt/vallox-vva75x125-difuzorine-dezute-plastikas-su-fiksatoriais-ir-aklemis",
    icon: "https://www.vedinimas.lt/images/uploader/vv/588x588.g/vva-2x75-125-vallox-difuzoriaus-dezute-su-fiksatoriais-ir-aklemis-3.jpg",
    code: "000385950",
    name: "Difuzoriaus pajungimo dėžė Vallox VVA 2x75-125",
    productGroup: "premium",
    good_id: 46599,
  },
  {
    url: "https://www.vedinimas.lt/climecon-line-125-oro-difuzorius",
    icon: "https://www.vedinimas.lt/images/uploader/cl/588x588.g/climecon-line-125-oro-difuzorius-1.png",
    code: "008735108",
    name: "Oro difuzorius LINE 125 Climecon",
    productGroup: "premium",
    good_id: 46911,
  }
];

export default MATERIALS_BOXES;
